module.exports = __webpack_public_path__ + "static/media/HotelX-Logo.5c548be9.png";